export default {
      id: "domain_navigation_bg-usage",
      viewBox: "0 0 334 231",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#domain_navigation_bg-usage",
      toString: function () {
        return this.url;
      }
    }